import React from 'react';
import Style from './calendar.module.css';
import jalaliToGregorian from './jalaliToGregorian';
/** @jsxImportSource @emotion/react */

import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { jsxs as _jsxs } from "@emotion/react/jsx-runtime";

const Calendar = props => {
  const calendarId = React.useId();
  let today = new Date().toLocaleDateString('fa-IR', {
    dateStyle: 'short',
    numberingSystem: 'latn'
  });
  let jalaliDateArray = today.split('،');
  const [jalaliCurrentMonth, setJalaliCurrentMonth] = React.useState(+jalaliDateArray[0].split('/')[1]);
  const [jalaliCurrentYear, setJalaliCurrentYear] = React.useState(+jalaliDateArray[0].split('/')[0]);
  const months = ['', 'فروردین', 'اردیبهشت', 'خرداد', 'تیر', 'مرداد', 'شهریور', 'مهر', 'آبان', 'آذر', 'دی', 'بهمن', 'اسفند'];
  const days = ['ش', 'ی', 'د', 'س', 'چ', 'پ', 'ج'];

  const showCalendar = (jalaliCurrentMonth, jalaliCurrentYear) => {
    document.getElementById(calendarId).querySelector('#calendarYearList').style.display = 'none';
    document.getElementById(calendarId).querySelector('#calendarMonthList').style.display = 'none';
    let currentMonthAndYear = document.getElementById(calendarId).querySelector('#calendarCurrentDateTitle');
    let gregorianDateArray = jalaliToGregorian(jalaliCurrentYear, jalaliCurrentMonth, 1);
    let gregorianDate = `${gregorianDateArray[0]}-${gregorianDateArray[1]}-${gregorianDateArray[2]}`;
    let jalaliFullDate = new Date(gregorianDate).toLocaleDateString('fa-IR', {
      dateStyle: 'full',
      numberingSystem: 'latn'
    });
    let firstDay;

    if (jalaliFullDate.split(' ')[3] === 'شنبه') {
      firstDay = 0;
    }

    if (jalaliFullDate.split(' ')[3] === 'یکشنبه') {
      firstDay = 1;
    }

    if (jalaliFullDate.split(' ')[3] === 'دوشنبه') {
      firstDay = 2;
    }

    if (jalaliFullDate.split(' ')[3] === 'سه‌شنبه') {
      firstDay = 3;
    }

    if (jalaliFullDate.split(' ')[3] === 'چهارشنبه') {
      firstDay = 4;
    }

    if (jalaliFullDate.split(' ')[3] === 'پنجشنبه') {
      firstDay = 5;
    }

    if (jalaliFullDate.split(' ')[3] === 'جمعه') {
      firstDay = 6;
    }

    let tbl = document.getElementById(calendarId).querySelector('#calendarCurrentDateBody');
    tbl.innerHTML = '';
    currentMonthAndYear.innerHTML = `<svg id="calendarPrev" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill="none" d="M0 0h24v24H0V0z" /><path d="M9.29 6.71a.996.996 0 0 0 0 1.41L13.17 12l-3.88 3.88a.996.996 0 1 0 1.41 1.41l4.59-4.59a.996.996 0 0 0 0-1.41L10.7 6.7c-.38-.38-1.02-.38-1.41.01z" /></svg>` + months[jalaliCurrentMonth] + ' ' + jalaliCurrentYear + '' + `<svg id="calendarNext" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill="none" d="M0 0h24v24H0V0z"/><path d="M14.71 6.71a.996.996 0 0 0-1.41 0L8.71 11.3a.996.996 0 0 0 0 1.41l4.59 4.59a.996.996 0 1 0 1.41-1.41L10.83 12l3.88-3.88c.39-.39.38-1.03 0-1.41z"/></svg>`;
    let calendarPrevIcon = document.getElementById(calendarId).querySelector('#calendarPrev');
    calendarPrevIcon.onclick = prev;
    let calendarNextIcon = document.getElementById(calendarId).querySelector('#calendarNext');
    calendarNextIcon.onclick = next;
    document.getElementById(calendarId).querySelector(`input[name=calendarCurrentDate]`).value = jalaliCurrentYear + '/' + jalaliCurrentMonth;
    let date = 1;

    for (var i = 0; i < 6; i++) {
      var row = document.createElement('tr');

      for (var j = 0; j < 7; j++) {
        if (i === 0 && j < firstDay) {
          let cell = document.createElement('td');
          let cellText = document.createTextNode('');
          cell.appendChild(cellText);
          row.appendChild(cell);
        } else if (date > daysInMonth(jalaliCurrentMonth, jalaliCurrentYear)) {
          break;
        } else {
          let cell = document.createElement('td');
          cell.setAttribute('data-date', date);
          cell.setAttribute('data-month', jalaliCurrentMonth);
          cell.setAttribute('data-year', jalaliCurrentYear);
          cell.innerHTML = '<div>' + date + '</div>';

          if (+jalaliCurrentYear === +jalaliDateArray[0].split('/')[0] && +jalaliCurrentMonth === +jalaliDateArray[0].split('/')[1] && +date === +jalaliDateArray[0].split('/')[2]) {
            cell.classList.add(`${Style.active}`);
          }

          row.appendChild(cell);
          date++;
        }
      }

      tbl.appendChild(row);
    }
  };

  const daysInMonth = (month, year) => {
    if (month === 11 || month === 10 || month === 9 || month === 8 || month === 7) {
      return 30;
    }

    if (month === 1 || month === 2 || month === 3 || month === 4 || month === 5 || month === 6) {
      return 31;
    }

    if (month === 12 && (year === 1300 || year === 1304 || year === 1309 || year === 1313 || year === 1317 || year === 1321 || year === 1325 || year === 1329 || year === 1333 || year === 1337 || year === 1342 || year === 1346 || year === 1350 || year === 1354 || year === 1358 || year === 1362 || year === 1366 || year === 1370 || year === 1375 || year === 1379 || year === 1383 || year === 1387 || year === 1391 || year === 1395 || year === 1399 || year === 1403 || year === 1408 || year === 1412 || year === 1416 || year === 1420 || year === 1424 || year === 1428 || year === 1432 || year === 1436 || year === 1441)) {
      return 30;
    } else if (month === 12 && (year !== 1300 || year !== 1304 || year !== 1309 || year !== 1313 || year !== 1317 || year !== 1321 || year !== 1325 || year !== 1329 || year !== 1333 || year !== 1337 || year !== 1342 || year !== 1346 || year !== 1350 || year !== 1354 || year !== 1358 || year !== 1362 || year !== 1366 || year !== 1370 || year !== 1375 || year !== 1379 || year !== 1383 || year !== 1387 || year !== 1391 || year !== 1395 || year !== 1399 || year !== 1403 || year !== 1408 || year !== 1412 || year !== 1416 || year !== 1420 || year !== 1424 || year !== 1428 || year !== 1432 || year !== 1436 || year !== 1441)) {
      return 29;
    }
  };

  const [reload, setReload] = React.useState('');

  const prev = () => {
    let currentYear = document.getElementById(calendarId).querySelector(`input[name=calendarCurrentDate]`).value.split('/')[0];
    let currentMonth = document.getElementById(calendarId).querySelector(`input[name=calendarCurrentDate`).value.split('/')[1];

    if (currentMonth > 1) {
      currentMonth = +currentMonth - 1;
      document.getElementById(calendarId).querySelector(`input[name=calendarCurrentDate]`).value = currentYear + '/' + currentMonth;
      showCalendar(currentMonth, currentYear);
    } else {
      currentMonth = 12;
      currentYear = +currentYear - 1;
      document.getElementById(calendarId).querySelector(`input[name=calendarCurrentDate`).value = currentYear + '/' + currentMonth;
      showCalendar(currentMonth, currentYear);
    }

    setReload(Math.floor(Math.random() * 100));
  };

  const next = () => {
    let currentYear = document.getElementById(calendarId).querySelector(`input[name=calendarCurrentDate`).value.split('/')[0];
    let currentMonth = document.getElementById(calendarId).querySelector(`input[name=calendarCurrentDate`).value.split('/')[1];

    if (currentMonth > 11) {
      currentMonth = 1;
      currentYear = +currentYear + 1;
      document.getElementById(calendarId).querySelector(`input[name=calendarCurrentDate]`).value = currentYear + '/' + currentMonth + 1;
      showCalendar(currentMonth, currentYear);
    } else if (currentMonth >= 1) {
      currentMonth = +currentMonth + 1;
      showCalendar(currentMonth, currentYear);
      document.getElementById(calendarId).querySelector(`input[name=calendarCurrentDate]`).value = currentYear + '/' + currentMonth;
    }

    setReload(Math.floor(Math.random() * 100));
  };

  const handleValue = date => {
    props.onChange(date);
  };

  React.useEffect(() => {
    let dataHead = '<tr>';

    for (let dhead in days) {
      dataHead += '<th data-days="' + days[dhead] + '">' + days[dhead] + '</th>';
    }

    dataHead += '</tr>';
    document.getElementById(calendarId).querySelector('#calendarCurrentDateHead').innerHTML = dataHead;
    document.getElementById(calendarId).querySelector('#calendarCurrentDateHead').innerHTML = dataHead;
    showCalendar(jalaliCurrentMonth, jalaliCurrentYear);
  }, [calendarId]);
  React.useEffect(() => {
    document.getElementById(calendarId).querySelectorAll('td').forEach(obj => {
      obj.onclick = () => handleValue(`${obj.getAttribute('data-year')}/${('0' + obj.getAttribute('data-month')).slice(-2)}/${('0' + obj.getAttribute('data-date')).slice(-2)}`);
    });
  }, [reload]);

  const toggleCalendarYearList = () => {
    document.getElementById(calendarId).querySelector('#calendarMonthList').style.display = 'none';
    document.getElementById(calendarId).querySelector('#calendarYearList').innerHTML = '';

    for (let i = 1311; i < 1491; i++) {
      let yearButton = document.createElement('button');
      yearButton.innerHTML = i;
      yearButton.value = i;
      yearButton.setAttribute('type', 'button');
      yearButton.onclick = setNewYear;
      document.getElementById(calendarId).querySelector('#calendarYearList').appendChild(yearButton);

      if (yearButton.value === jalaliDateArray[0].split('/')[0]) {
        yearButton.classList.add(`${Style.active}`);
      }
    }

    if (window.getComputedStyle(document.getElementById(calendarId).querySelector('#calendarYearList')).display === 'none') {
      document.getElementById(calendarId).querySelector('#calendarYearList').style.display = 'block';
      let yearButtonArray = document.getElementById(calendarId).querySelectorAll('#calendarYearList button');
      yearButtonArray.forEach(obj => {
        if (+obj.value === +jalaliDateArray[0].split('/')[0]) {
          document.getElementById(calendarId).querySelector('#calendarYearList').scrollTop = obj.offsetTop;
        }
      });
    } else {
      document.getElementById(calendarId).querySelector('#calendarYearList').style.display = 'none';
    }
  };

  const toggleCalendarMonthList = () => {
    document.getElementById(calendarId).querySelector('#calendarYearList').style.display = 'none';
    document.getElementById(calendarId).querySelector('#calendarMonthList').innerHTML = '';

    for (let i = 1; i < months.length; i++) {
      let monthButton = document.createElement('button');
      monthButton.innerHTML = months[i];
      monthButton.value = i;
      monthButton.setAttribute('type', 'button');
      monthButton.onclick = setNewMonth;
      document.getElementById(calendarId).querySelector('#calendarMonthList').appendChild(monthButton);

      if (+monthButton.value === +jalaliDateArray[0].split('/')[1]) {
        monthButton.classList.add(`${Style.active}`);
      }
    }

    if (window.getComputedStyle(document.getElementById(calendarId).querySelector('#calendarMonthList')).display === 'none') {
      document.getElementById(calendarId).querySelector('#calendarMonthList').style.display = 'block';
    } else {
      document.getElementById(calendarId).querySelector('#calendarMonthList').style.display = 'none';
    }
  };

  const setNewYear = event => {
    setJalaliCurrentYear(+event.target.value);
    showCalendar(jalaliCurrentMonth, +event.target.value);
    setReload(Math.floor(Math.random() * 100));
  };

  const setNewMonth = event => {
    setJalaliCurrentMonth(+event.target.value);
    showCalendar(+event.target.value, jalaliCurrentYear);
    setReload(Math.floor(Math.random() * 100));
  };

  return _jsx(React.Fragment, {
    children: _jsx("div", {
      id: calendarId,
      className: `${Style.wrapper}`,
      children: _jsxs("div", {
        className: `${Style.calendarContainer}`,
        children: [_jsx("input", {
          name: 'calendarCurrentDate',
          type: "hidden"
        }), _jsx("h3", {
          id: 'calendarCurrentDateTitle'
        }), _jsxs("table", {
          id: 'calendarCurrentDate',
          children: [_jsx("thead", {
            id: 'calendarCurrentDateHead'
          }), _jsx("tbody", {
            id: 'calendarCurrentDateBody'
          })]
        }), _jsxs("div", {
          className: `${Style.toolbar}`,
          children: [_jsx("button", {
            onClick: toggleCalendarYearList,
            type: "button",
            children: "\u0627\u0646\u062A\u062E\u0627\u0628 \u0633\u0627\u0644"
          }), _jsx("button", {
            onClick: toggleCalendarMonthList,
            type: "button",
            children: "\u0627\u0646\u062A\u062E\u0627\u0628 \u0645\u0627\u0647"
          })]
        }), _jsx("div", {
          id: 'calendarYearList',
          className: `${Style.yearList}`
        }), _jsx("div", {
          id: 'calendarMonthList',
          className: `${Style.monthList}`
        })]
      })
    })
  });
};

export default Calendar;